export default class PagingRequest {
    public page?: number;
    public pageSize?: number;
    public sortField?: string;
    public sortDesc?: boolean;
    public filter?: string;

    constructor(queryParamsString?: string) {
        if (queryParamsString != undefined) {
            this.fromQueryParams(queryParamsString);
        }
        else {
            this.setDefaults();
        }
    }

    public static Copy(other: PagingRequest): PagingRequest {
        let pagingRequest = new PagingRequest();
        pagingRequest.page = other.page;
        pagingRequest.pageSize = other.pageSize;
        pagingRequest.sortField = other.sortField;
        pagingRequest.sortDesc = other.sortDesc;
        pagingRequest.filter = other.filter;
        return pagingRequest;
    }

    public static AreEqual(a: PagingRequest, b: PagingRequest): boolean {
        return a.page == b.page &&
            a.pageSize == b.pageSize &&
            a.sortField == b.sortField &&
            a.sortDesc == b.sortDesc &&
            a.filter == b.filter;
    }

    public GetNumberOfPages(totalItems: number): number {
        var pageCount = Math.floor(totalItems / this.pageSize!);

        if (totalItems % this.pageSize! != 0) {
            pageCount += 1;
        }

        return pageCount;
    }

    public addPage(numberOfPages: number) {
        if (this.page == undefined) {
            this.page = 0;
        }

        this.page += numberOfPages;

        if (this.page < 0) {
            this.page = 0;
        }
    }

    public toQueryParams(): string {
        const searchParams = new URLSearchParams();
        if (this.page != undefined) {
            searchParams.append("page", this.page.toString());
        }
        if (this.pageSize != undefined) {
            searchParams.append("pageSize", this.pageSize.toString());
        }
        if (this.sortField != undefined) {
            searchParams.append("sortField", this.sortField);
        }
        if (this.sortDesc != undefined) {
            searchParams.append("sortDesc", this.sortDesc.toString());
        }
        if (this.filter != undefined) {
            searchParams.append("filter", this.filter);
        }
        return `?${searchParams.toString()}`;
    }

    public fromQueryParams(queryParamString: string): void {
        const searchParams = new URLSearchParams(queryParamString);
        this.page = this.parseNumber(searchParams, "page");
        this.pageSize = this.parseNumber(searchParams, "pageSize");
        this.sortField = this.parseString(searchParams, "sortField");
        this.sortDesc = this.parseBoolean(searchParams, "sortDesc");
        this.filter = this.parseString(searchParams, "filter");

        this.setDefaults();
    }

    private setDefaults() {

        if (this.page == undefined) {
            this.page = 0; // default
        }

        if (this.pageSize == undefined) {
            this.pageSize = 10; // default
        }
    }

    private parseString(searchParams: URLSearchParams, name: string): string | undefined {
        const stringValue = searchParams.get(name);
        if (stringValue != null) {
            return stringValue;
        }
        return undefined;
    }

    private parseNumber(searchParams: URLSearchParams, name: string): number | undefined {
        const stringValue = searchParams.get(name);
        if (stringValue != null) {
            const numberValue = Number.parseInt(stringValue);
            if (!Number.isNaN(numberValue)) {
                return numberValue;
            }
        }
        return undefined;
    }

    private parseBoolean(searchParams: URLSearchParams, name: string): boolean | undefined {
        const stringValue = searchParams.get(name);
        if (stringValue != null) {
            if (stringValue.toLowerCase() === "true") {
                return true;
            }
            if (stringValue.toLowerCase() === "false") {
                return false;
            }
        }
        return undefined;
    }
}